import { ButtonProps, Button as MuiButton } from '@mui/material';

export default function Button({ sx, ...props }: ButtonProps) {
  return (
    <MuiButton
      color="primary"
      variant="contained"
      sx={{ height: '100%', py: 1, px: 2, minWidth: 'fit-content', ...sx }}
      {...props}
    />
  );
}
